<template>
  <div id="">
      <div class="top">
        <h1>药知企业教育平台</h1>
        <h3>专一、专注、专业</h3>
        </div>
    <div class="main">
      <h1 class="center">找回密码</h1>
      <el-steps :active="active" finish-status="success">
        <el-step title="找回方式"></el-step>
        <el-step title="安全验证"></el-step>
        <el-step title="重置密码"></el-step>
        <el-step title="完成"></el-step>
      </el-steps>
      <div class="con" v-if="active === 0">
        <div @click="num=1"><el-radio class="step1" v-model="radio" label="1">邮箱验证</el-radio></div>
        <div @click="num=2"><el-radio class="step1" v-model="radio" label="2">手机号验证</el-radio></div>
        <br />
        <div class="con-button">
          <el-button @click="next(1)">下一步</el-button>
        </div>

      </div>
      <div class="con" v-if="active === 1">
        <div id="email" v-show="num==1">
          <el-input placeholder="请输入邮箱" v-model.trim="data.mail"><template slot="prepend"><i class="el-icon-message"></i></template></el-input>
          <el-input v-model.trim="data.mailcode" placeholder="请输入验证码"><template slot="prepend"><i class="el-icon-key"></i></template><el-button slot="append" @click="send_code()">{{check_text}}</el-button></el-input>
        </div>
        <div id="phone" v-show="num==2">
            <el-input placeholder="请输入手机号" v-model.trim="data.phone"><template slot="prepend"><i class="el-icon-phone-outline"></i></template></el-input>
          <el-input v-model.trim="data.phonecode" placeholder="请输入验证码"><template slot="prepend"><i class="el-icon-key"></i></template><el-button slot="append" @click="send_code()">{{check_text}}</el-button></el-input>
        </div >
        <br />
        <div class="con-button">
          <el-button @click="back(0)">上一步</el-button>
          <el-button @click="next(2)">下一步</el-button>
        </div>
      </div>
      <div class="con" v-if="active === 2">
        <br />新的登录密码：<br /><br /><el-input type="password" v-model.trim="data.pwd" placeholder="请输入密码" clearable></el-input>
        <el-alert
            title="8-20位密码，密码必须同时包含大小写字母及数字"
            type="info"
            :closable="false" show-icon>
          </el-alert><br /><br />
        确认新的登录密码：<br /><br /><el-input type="password" v-model.trim="data.pwd_re" placeholder="请输入密码" clearable></el-input>
        <!-- <el-alert title="两次密码不一致" type="error" :closable="false" show-icon> </el-alert> -->
        <br />
        <div class="con-button">
          <el-button @click="back(1)">上一步</el-button>
          <el-button @click="update_pwd()">确定</el-button>
        </div>
      </div>
      <div>
        <el-dialog title="经检测您有多家企业账户" :visible.sync="dialogFormVisible">
          <el-form :model="data">
            <el-form-item label="请您选择登录账户" :label-width="formLabelWidth">
              <el-select v-model="data.info" placeholder="请您选择登录账户" style="width: 75%;">
                <el-option v-for="(item,index) in select_list" :key="index" :label="item.company.name" :title="item.rale_name" :value="index"></el-option>
              </el-select>
            </el-form-item>
          </el-form>

          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogFormVisible=false">确 定</el-button>
          </div>
        </el-dialog>
      </div>
      <div class="con success" v-if="active === 4"><br />
        <i class="el-icon-success"></i><br />
        密码设置成功
        <br />
        <div class="con-button">
          <el-button type="success" round @click="login">返回登录</el-button>
        </div>
      </div>
    </div>
  <footerbom></footerbom>
  </div>
</template>

<script>
  import Footer from '../components/index/public/NavFooter.vue';
  export default {
    data() {
      return {
        active: 0,
        radio: '1',
        num:1,
        check_text:'获取验证码',
        data:{
          phone:'',
          mail: '',
          phonecode:'',
          mailcode:'',
          pwd:'',
          pwd_re:'',
        },
        select_list:'',
        select_form:{},
        dialogFormVisible: false,
        formLabelWidth: '30%',
        timer:null,
        last:60,
      };
    },
    components:{
      footerbom:Footer
    },
    methods: {
      //下一步
      next(num) {
        let _this=this;
        if(num==2 && !_this.info_check){
            _this.check_msg();
            return false;
        }
        _this.active = num;
      },
      //上一步
      back(num) {
        this.active = num;
      },
      //跳转登录页面
      login () {
        this.$router.push('/login')
      },
      //收到验证码倒计时
      change_info_check(){
        let _this=this;
        if(_this.timer == null) {
          _this.timer = setInterval( () => {
            if(_this.last>0){
              _this.check_text=_this.last+'s后重新获取';
              _this.last--;
            }else{
              clearInterval(_this.timer);
              _this.timer=null;
              _this.last=60;
              _this.check_text='获取验证码';
            }
          }, 1000)
        }
      },
      //获取验证码
      send_code(){
        let _this=this;
        if(_this.check_text!='获取验证码'){
          return false;
        }
        if(_this.num==1){
          _this.data.type='mail';
          _this.data.value=_this.email;
        }else{
          _this.data.type='phone';
          _this.data.value=_this.phone;
        }
        _this.data.msg='2'
        _this.axios.post('/v2/login/send_code', {
          data: _this.data //注意post请求发送参数的方式和get请求方式是有区别的
        }).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.$message.success(res.data.msg);//弹框
              _this.change_info_check();
            }else{
              _this.$message.error(res.data.msg);
            }
          }else{
            _this.$message.error('服务器内部错误');
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误');
        });
      },
      check_msg(){
        let _this=this;
        if(_this.num==1){
          _this.data.type='mail';
        }else{
          _this.data.type='phone';
        }
        _this.axios.post('/v2/login/check_msg', {
          data: _this.data //注意post请求发送参数的方式和get请求方式是有区别的
        }).then(function(res) {
          if(res.status=='200'){
            if(res.data.code!='1'){
              _this.$message.error(res.data.msg);
            }else{
              _this.select_list=res.data.data;
              _this.active = 2;
              _this.dialogFormVisible=true;
            }
          }else{
            _this.$message.error('服务器内部错误');
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误');
        });
      },
      //上传新密码
      update_pwd(){
        let _this=this;
        if(_this.data.info==null){
          _this.dialogFormVisible=true;
          return false;
        }
        _this.axios.post('/v2/login/update_pwd', {
          data: _this.data //注意post请求发送参数的方式和get请求方式是有区别的
        }).then(function(res) {
          if(res.status=='200'){
            if(res.data.code!='1'){
              _this.$message.error(res.data.msg);
            }else{
              _this.active = 4;
            }
          }else{
            _this.$message.error('服务器内部错误');
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误');
        });
      },
    },
  }
</script>

<style scoped>
  .left {
    float: left;
  }

  .right {
    float: right;
  }

  .center {
    text-align: center;
  }
  .top{
    width: 60%;
    height: 120px;
    background-color: #336397;
    color: white;
    padding: 0 20%;
  }
  .top h1{
    padding: 30px;
    float: left;
    margin: 0;
  }
  .top h3{
    padding: 20px;
    margin: 0;
    float: right;
    position: relative;
    right: 20px;
    top: 50px;
  }
  .main {
    min-height: calc(100vh - 260px);
    width: 60%;
    margin: 0 20%;
  }
  .main h1{
    margin: 0;
     padding: 20px;
   }
  .con {
    width: 60%;
    margin: 20px 20%;
  }

  .step1 {
    margin: 20px;
  }

  .con-button {
    margin-top: 30px;
    text-align: center;
  }
  .con .el-input-group{
    margin: 20px;
  }
  .success{
    color: green;
    font-size: 20px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/view/Findpwd.vue